import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { School } from "../../../types/Schools";
import { purgeSchools, searchSchools } from "../../../utils/api/Schools";
import { useToast } from "@familyzone/component-library";
import SchoolsTable from "./SchoolsTable";
import { IdentitySearch, IdentitySearchParams } from "../IdentitySearch/IdentitySearch";

const Schools: React.FC = (): JSX.Element => {
  const PAGE_SIZE = 25;
  const { successToast, errorToast } = useToast();
  const [schools, setSchools] = useState<School[]>([]);
  const [loading, setLoading] = useState(false);

  const search = useCallback((params: IdentitySearchParams): Promise<School[]> => {
    return searchSchools(params.query, params.pageSize);
  }, []);

  const handlePurgeSchools = () => {
    purgeSchools()
      .then(() => {
        successToast({
          title: "Success!",
          description: "We've received the request and it has been sent for processing.",
        });
      })
      .catch(() => {
        errorToast({
          title: "Error",
          description: "We're not able to process the purge at this time. Please try again later.",
        });
      });
  };

  return (
    <SchoolsTable
      schools={schools}
      loaded={!loading}
      onPurgeSchools={handlePurgeSchools}
      withinTableChildren={<IdentitySearch<School> setState={setSchools} setLoading={setLoading} searchFn={search} pageSize={PAGE_SIZE} />}
      isSearching={loading}
    />
  );
};

Schools.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default Schools;
